// extracted by mini-css-extract-plugin
export default {"adminPanel":"adminPanelButton_adminPanel__5OkKD","adminPanelText":"adminPanelButton_adminPanelText__ADf2+"};